import React from 'react';
import { CRBN_ORANGE_LOGO } from '@shared_components/index'; // Adjust the import path as necessary



export const RXNavbar = () => {
    return (
        <nav className="bg-black text-white p-4 sticky top-0 z-50 font-karla">
            {/* Container for navbar elements.
                - Mobile: flex-col to stack items, items-center to center them horizontally.
                - Desktop (md): flex-row to align items horizontally, items-center to align them vertically.
                                 justify-start to push the logo to the left.
                                 relative is crucial for absolute positioning of the title.
                                 md:h-16 sets a fixed height on desktop for stable vertical centering of the title.
            */}
            <div className="container mx-auto flex flex-col items-center md:flex-row md:items-center md:justify-start relative md:h-16">
                {/* Logo container */}
                {/* flex-shrink-0 prevents the logo from shrinking if space is constrained. */}
                <div className="flex-shrink-0">
                    <img src={CRBN_ORANGE_LOGO} alt="Logo" className="h-8" />
                </div>

                {/* Title container */}
                {/* Mobile: mt-2 adds space below the logo. Text is centered due to h1's text-center.
                    Desktop (md): md:mt-0 resets mobile margin.
                                 md:absolute positions it relative to the parent container.
                                 md:left-1/2, md:top-1/2, md:-translate-x-1/2, md:-translate-y-1/2 centers the div.
                */}
                <div className="mt-2 md:mt-0 md:absolute md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2">
                    <h1 className="text-3xl font-bold font-unica text-custom-orange whitespace-nowrap text-center">
                        CUSTOM CRBN
                    </h1>
                </div>
            </div>
        </nav>
    );
};
